import cn from 'clsx'
import { FC, useContext } from 'react'

import { Button } from '@/components/ui'

import { STATUS, STEP_TYPE } from '@/constants/common'
import { DraftsContext } from '@/features/Home/components/shotlistUpload/DraftsContext'

interface IModalWindowHeaderProps {
	taskId: string
	selectedWay: string
	setSelectedWay: (way: string) => void
	setIsModalOpen: (open: boolean) => void
	hideBackButton?: boolean
	status?: string
	openFormModal?: boolean
	isUploaded: boolean
}

const ModalWindowHeader: FC<IModalWindowHeaderProps> = ({
	taskId,
	selectedWay,
	setSelectedWay,
	setIsModalOpen,
	hideBackButton,
	status,
	openFormModal,
	isUploaded
}) => {
	const { removeDraft } = useContext(DraftsContext)
	// Determine current step for timeline styling

	// Step 2-a: "Select source language" - when TRANSCRIBE is selected and not finished
	const isSelectSourceLanguage =
		selectedWay === STEP_TYPE.TRANSCRIBE &&
		status !== STATUS.FINISHED &&
		!openFormModal

	// Step 2-b: "Select platform" - when Upload is selected
	const isSelectPlatform = selectedWay === STEP_TYPE.UPLOAD && !openFormModal

	// Step 3: Form - when UPLOAD is selected and form modal is open
	const isFormStep = selectedWay === STEP_TYPE.UPLOAD && openFormModal

	const secondStep = isSelectSourceLanguage || isSelectPlatform

	const handleCloseButton = () => {
		if (!isFormStep) {
			setSelectedWay('')
		}

		if (isUploaded) {
			removeDraft(taskId)
		}

		setIsModalOpen(false)
	}

	return (
		<div className='flex mb-8'>
			{!hideBackButton && (
				<Button
					className={cn(
						'rounded-[8px] py-[6px] hover:bg-gray-200',
						selectedWay ? 'opacity-1 cursor-pointer' : 'opacity-0 cursor-auto'
					)}
					classNameText='text-black'
					onClick={() => setSelectedWay('')}
				>
					Back
				</Button>
			)}
			<div className='flex items-center mx-auto gap-[1px]'>
				{/* First point */}
				<div
					className={cn(
						'w-[10px] h-[10px] rounded-full bg-black',
						!secondStep &&
							!isFormStep &&
							'!w-4 !h-4 border-[6px] border-black bg-white'
					)}
				/>
				{/* First line */}
				<div
					className={cn(
						'w-[60px] h-[2px]',
						secondStep || isFormStep ? 'bg-black' : 'bg-gray-300'
					)}
				/>
				{/* Second point */}
				<div
					className={cn(
						'w-[10px] h-[10px] rounded-full bg-gray-400',
						isFormStep && '!bg-black',
						secondStep && '!w-4 !h-4 border-[6px] border-black bg-white'
					)}
				/>
				{/* Second line */}
				{selectedWay !== STEP_TYPE.TRANSCRIBE && (
					<div
						className={cn(
							'w-[60px] h-[2px]',
							isFormStep ? 'bg-black' : 'bg-gray-300'
						)}
					/>
				)}
				{/* Third point */}
				{selectedWay !== STEP_TYPE.TRANSCRIBE && (
					<div
						className={cn(
							'w-[10px] h-[10px] rounded-full',
							isFormStep
								? '!w-4 !h-4 border-[6px] border-black bg-white'
								: 'bg-gray-400'
						)}
					/>
				)}
			</div>
			<Button
				className='rounded-[8px] py-[6px] hover:bg-gray-200'
				classNameText='text-black'
				onClick={handleCloseButton}
			>
				Close
			</Button>
		</div>
	)
}

export default ModalWindowHeader
